import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">

        <div className="footer-section">
            
            <ul className="footer-contact">
              
              <li>
                <i className="logo-rqm"></i>
              </li>
              <li>
                <i className="icon-map-marker"></i>
                <span>300, allée des Ursulines, Bureau K-316,</span>
              </li>
              <li>
                <i className="icon-map-marker"></i>
                <span>Rimouski (Québec)  G5L 3A1</span>
              </li>
              <li>
                <i className="icon-phone"></i>
                <span>418 723-1986, poste 1820</span>
              </li>
              <li>
                <i className="icon-envelope"></i>
                <a href="mailto:info-rqm@uqar.ca">info-rqm@uqar.ca</a>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h3 className="footer-title">explorez RQM</h3>
            <p>
              Répertoire d'expertises maritime pour les projets de recherche en sciences de la mer.
              Facilitez la coopération dans secteur maritime.
            </p>
          </div>
          
          <div className="footer-section" style={{ marginLeft: '50px' }}>
            <h3 className="footer-title">Liens rapides</h3>
            <ul className="footer-links">
              <li><Link to="/">Accueil</Link></li>
              <li><Link to="/directory">Répertoire</Link></li>
              <li><Link to="/register">S'inscrire</Link></li>
              <li><Link to="/login">Se connecter</Link></li>
              <li><Link to="/terms">Conditions d'utilisation</Link></li>
              <li><Link to="/privacy">Politique de confidentialité</Link></li>
            </ul>
          </div>
          
        </div>
        
        <div className="footer-bottom">
          <div className="logo-quebec logo-quebec-center"></div>
          <p>&copy; {currentYear} Réseau Québec maritime (RQM). Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
